/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    FollowGate,
    instanceOfFollowGate,
    FollowGateFromJSON,
    FollowGateFromJSONTyped,
    FollowGateToJSON,
} from './FollowGate';
import {
    NftGate,
    instanceOfNftGate,
    NftGateFromJSON,
    NftGateFromJSONTyped,
    NftGateToJSON,
} from './NftGate';
import {
    PurchaseGate,
    instanceOfPurchaseGate,
    PurchaseGateFromJSON,
    PurchaseGateFromJSONTyped,
    PurchaseGateToJSON,
} from './PurchaseGate';
import {
    TipGate,
    instanceOfTipGate,
    TipGateFromJSON,
    TipGateFromJSONTyped,
    TipGateToJSON,
} from './TipGate';

/**
 * @type AccessGate
 * 
 * @export
 */
export type AccessGate = FollowGate | NftGate | PurchaseGate | TipGate;

export function AccessGateFromJSON(json: any): AccessGate {
    return AccessGateFromJSONTyped(json, false);
}

export function AccessGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...FollowGateFromJSONTyped(json, true), ...NftGateFromJSONTyped(json, true), ...PurchaseGateFromJSONTyped(json, true), ...TipGateFromJSONTyped(json, true) };
}

export function AccessGateToJSON(value?: AccessGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfFollowGate(value)) {
        return FollowGateToJSON(value as FollowGate);
    }
    if (instanceOfNftGate(value)) {
        return NftGateToJSON(value as NftGate);
    }
    if (instanceOfPurchaseGate(value)) {
        return PurchaseGateToJSON(value as PurchaseGate);
    }
    if (instanceOfTipGate(value)) {
        return TipGateToJSON(value as TipGate);
    }

    return {};
}

